module.exports = __webpack_public_path__ + "static/media/airblitz-5.19d63d74.jpg";